/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {DDayGameAssets} from "./DDayGameAssets";
import {BlitzKriegSound} from "./sound/BlitzKriegSound";
import {DDayBackground} from "./view/DDayBackground";
import {BlitzKriegWinPresentation} from "./gameflow/BlitzKriegWinPresentation";
import {BlitzKriegNormalBetPresentation} from "./gameflow/BlitzKriegNormalBetPresentation";
import {BlitzKriegNormalResultPresentation} from "./gameflow/BlitzKriegNormalResultPresentation";
import {DDayPickAndClickIdlePresentation} from "./gameflow/DDayPickAndClickIdlePresentation";
import {BlitzKriegNormalIdlePresentation} from "./gameflow/BlitzKriegNormalIdlePresentation";
import {IBlitzKriegGameData, ISymbolValues} from "./server/data/IBlitzKriegData";
import {BlitzKriegModel} from "./server/BlitzKriegModel";
import {DDayLayers, Layers} from "./view/DDayLayers";
import {BlitzKriegReelController} from "./reels/BlitzKriegReelController";
import {DDayGameConfig} from "./DDayGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {BlitzKriegFreespinIdlePresentation} from "./gameflow/BlitzKriegFreespinIdlePresentation";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {WinCapScreen} from "./screen/WinCapScreen";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {DDayReelBackground} from "./view/ReelBackground/DDayReelBackground";
import {TimelineLite} from "gsap";
import {Impact} from "./Font/Impact";
import {ShakeEffect} from "./utils/ShakeEffect";
import {DDayGameFeatureController} from "./winpresentation/presentations/DDayGameFeatureController";
import {DDayFeatureBackground} from "./view/DDayFeatureBackground";
import {DDayIntroSplashView} from "./view/DDayIntroSplashView";
import {BlitzKriegGameMode} from "./server/BlitzKriegGameMode";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {DDayScatterAnticipationView} from "./view/DDayScatterAnticipationView";
import {CommonService} from "./utils/CommonService";
import {BlitzKriegParsedInitData} from "./server/data/BlitzKriegParsedInitData";
import {BonusFeatureData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/BonusFeatures";
import {GameSetting} from "../setting/GameSetting";
import {Speedster} from "../debug/Speedster";
import {TestTool} from "../debug/DataChecker/Internal/TestTool";
import {ReelStartPresentationManager} from "./reelstartpresentation/ReelStartPresentationManager";
import {ReelStartSoundController} from "./reelstartpresentation/presentations/ReelStartSoundController";
import {TypeWriter} from "./Font/TypeWriter";
import {DDayAtomicWildFeatureView} from "./view/DDayAtomicWildFeatureView";
import {DDayFreespinIntro} from "./screen/DDayFreespinIntro";
import {DDayPickAndClickWinPresentation} from "./gameflow/DDayPickAndClickWinPresentation";
import {InitialWinCountUpController} from "./winpresentation/presentations/initial/InitialWinCountUpController";
import {DDayPickAndClickBetPresentation} from "./gameflow/DDayPickAndClickBetPresentation";
import {DDayPickAndClickResultPresentation} from "./gameflow/DDayPickAndClickResultPresentation";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DDayNoWinController} from "./winpresentation/presentations/noWin/DDayNoWinController";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {GameHelper} from "../core/utils/GameHelper";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

export class DDay extends SlotGame {
    public static model: BlitzKriegModel;
    public static isActionSpinsActive: boolean = false;
    public static gameFlowController: GameFlowController;
    public static assetLoader: AssetLoader;
    public static reels: BlitzKriegReelController[];
    public static reelStopPresentations: ReelStopPresentationManager;
    public static reelStartPresentations: ReelStartPresentationManager;
    public static winPresentations: WinPresentationManager;
    public static initialCountUp: InitialWinCountUp;
    public static bigWinCountUp: BigWinCountUp;
    public static individualWin: IndividualWinController;
    public static freespinIntro: DDayFreespinIntro;
    public static freespinOutro: FreespinOutro;
    public static winCapScreen: WinCapScreen;
    public static reelBackground: DDayReelBackground;
    public static featureBackground: DDayFeatureBackground;
    public static backgroundView: DDayBackground;
    public static introSplash: DDayIntroSplashView;
    public static commonService: CommonService;

    public static atomicWildAnimation: DDayAtomicWildFeatureView;

    public static scatterAnticipation: DDayScatterAnticipationView;
    public static fireOverlays: PIXI.spine.Spine[][] = [[], [], [], [], []];
    public static bulletOverlays: PIXI.spine.Spine[][] = [[], [], [], [], []];
    public static shake: ShakeEffect;
    private static symbolTitleText: any = {
        "M1": "Howitzer",
        "M2": "Stuka",
        "M3": "Bomber",
        "M4": "Panzer",
        "L1": "Fighter Pilot",
        "L2": "Anti-Air",
        "L3": "Foot Soldier",
        "L4": "Commando",
        "W": ""
    }
    private skinner:Skinner;
    constructor() {
        super();
        const validSkins:string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit(){
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady() : Promise<any>{
        if (this.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();
            //Bonus
            replaceMap.set("feature2", "Intro_Feature_2.png")
            replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
            replaceMap.set("pageImage_10", "pageImage_10.png");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }
    public async init(): Promise<NolimitPlugin> {
        const value = await super.init();

        DDayGameConfig.updateReelSets();
        DDay.model = new BlitzKriegModel(SlotGame.apiPlugin, true);
        DDay.gameFlowController = new GameFlowController(SlotGame.apiPlugin, DDay.model);
        DDay.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        //Example
        DDay.model.events?.on(GameModelEvent.GAME, (data: IBlitzKriegGameData) => {
            console.log(data);
        });

        const idleNormal = new BlitzKriegNormalIdlePresentation();
        const reelStart = new BlitzKriegNormalBetPresentation();
        const normalResult = new BlitzKriegNormalResultPresentation();
        const freespinIdle = new BlitzKriegFreespinIdlePresentation();
        const winPres = new BlitzKriegWinPresentation();
        const pickAndClickIdle = new DDayPickAndClickIdlePresentation();
        const pickAndClickBet = new DDayPickAndClickBetPresentation();
        const pickAndClickResult = new DDayPickAndClickResultPresentation();
        const pickAndClickWin = new DDayPickAndClickWinPresentation();

        DDay.gameFlowController.addGameModeFlowStatePresentationMap(BlitzKriegGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, idleNormal],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        DDay.gameFlowController.addGameModeFlowStatePresentationMap(BlitzKriegGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        DDay.gameFlowController.addGameModeFlowStatePresentationMap(BlitzKriegGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        DDay.gameFlowController.addGameModeFlowStatePresentationMap(BlitzKriegGameMode.FS_PICK, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, pickAndClickIdle],
            [FlowState.BET, pickAndClickBet],
            [FlowState.RESULT, pickAndClickResult],
            [FlowState.WIN, pickAndClickWin]
        ]));
        this.handleSweepInit();
        return value;
    }

    public static createTimelineForAnimation(spine: PIXI.spine.Spine, trackIndex: number, animationName: string, loop: boolean, animationAlpha: number = 1, mixDuration: number = 0, resetOnComplete: boolean = true): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            repeat: loop ? -1 : 0
        });

        // trying safe checks for #136
        if (!spine.spineData || !spine.state) {
            return tl;
        }

        const animation: PIXI.spine.core.Animation = spine.spineData.findAnimation(animationName);
        if (!animation) {
            throw new Error(`No animation named ${animationName}`);
        }

        spine.autoUpdate = false;

        const setAnimation: () => void = () => {
            // trying safe check for #136
            if (spine.state) {
                const trackEntry: PIXI.spine.core.TrackEntry = spine.state.setAnimationWith(trackIndex, animation, false);
                trackEntry.alpha = animationAlpha;
                trackEntry.mixDuration = mixDuration;
            }
        };

        const target = {
            playHead: 0,
            spine: spine,
            prevTime: 0
        };

        const updateFunc: () => void = () => {
            // trying safe checks for #136
            if (spine && target) {
                const now = target.playHead;
                spine.update(now - target.prevTime);
                target.prevTime = now;
            }
        };

        tl.add(() => {
            target.prevTime = 0;
            setAnimation();
        });
        tl.fromTo(target, {playHead: 0}, {
            duration: animation.duration,
            playHead: animation.duration,
            onUpdate: updateFunc,
            ease: "none"
        });
        if (resetOnComplete) {
            tl.add(() => {
                target.prevTime = 0;
                setAnimation();
            });
        }
        tl.to(target, {duration: 0.0001}); //Needed so gsap does not skip "setAnimation" during reverse play.
        tl.add(() => {
            target.playHead = animation.duration;
            updateFunc();
        });

        return tl;
    }

    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {

            let symbolDataValueData: ISymbolValues = {
                "W": {3: 5, 4: 10, 5: 20},
                "L1": {3: 5, 4: 10, 5: 20},
                "L2": {3: 5, 4: 10, 5: 20},
                "L3": {3: 4, 4: 8, 5: 15},
                "L4": {3: 3, 4: 6, 5: 15},
                "M1": {3: 15, 4: 30, 5: 80},
                "M2": {3: 10, 4: 20, 5: 60},
                "M3": {3: 9, 4: 18, 5: 40},
                "M4": {3: 8, 4: 16, 5: 25},
            };
            if (DDay.model.parsedInitData.symbolValues) {
                symbolDataValueData = DDay.model.parsedInitData.symbolValues;
                Logger.logDev("Using symbolValues from INIT data");
            } else {
                Logger.logDev("Using default symbolValues");
            }
            const data = {
                skinPath: "screens/images/"
            };
            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            for (let key in symbolDataValueData) {
                paytableString = paytableString.replace(`{{${key}}}`, DDay.getSymbolString(key, symbolDataValueData[key]))
            }
            resolve(paytableString);
        });
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        let symbol: string = "";
        if (key !== "W") {
            symbol = `<div class="symbol">
            <p style="margin-bottom: 0px !important;"> ${DDay.symbolTitleText[key]}</p>
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>`;
        }
        return symbol;
    }

    public async getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();
        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(Impact.NORMAL_400);
        fontLoader.add(TypeWriter.NORMAL_400);
        AssetsConfig.addToAssetsConfig(DDayGameAssets.RESOURCES_GROUPS);
        DDay.assetLoader = new AssetLoader(DDay.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        const promises = Promise.all([fontLoader.load(), DDay.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);
        return promises.then((values: any) => {
            this.createViewsAndComponents();


            DDay.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
                if (data === true) {
                    DDay.isActionSpinsActive = true;
                    DDay.individualWin.stop();
                } else {
                    DDay.isActionSpinsActive = false;
                }
            });

            return value;
        });
    }

    public async getReadyToStart(): Promise<NolimitPlugin> {
        BlitzKriegSound.playTrack({name: BlitzKriegSound.INTRO_LOOP});
        return await super.getReadyToStart();
    }

    public async start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        const value = await super.start();
        DDay.gameFlowController.start();
        BlitzKriegSound.stopTrack(BlitzKriegSound.INTRO_LOOP);
        if (DDay.model.data.nextMode === BlitzKriegGameMode.NORMAL) {
            BlitzKriegSound.switchMusic({name: BlitzKriegSound.getMusicNameByMode(DDay.model.data.mode)});
            BlitzKriegSound.playTrack({name: "mainXbet", volume: 0});
            BlitzKriegSound.fadeTrack({name: "mainXbet", to: 0, from: 0, duration: 0});
        }


        DDay.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, (data: any) => {
            if (DDay.apiPlugin.betFeatureController.getActiveBetFeature()) {
                if (DDay.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "BOOSTED_BET") {
                    DDay.backgroundView.changeBackground(BlitzKriegGameMode.NORMAL, true);
                } else if (DDay.apiPlugin.betFeatureController.getActiveBetFeature()?.name !== "BOOSTED_BET") {
                    DDay.backgroundView.changeBackground(BlitzKriegGameMode.NORMAL, false);
                }
            } else {
                DDay.backgroundView.changeBackground(BlitzKriegGameMode.NORMAL, false);
            }
        });

        if (DDay.apiPlugin.isReplay) {
            if (DDay.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "BOOSTED_BET") {
                DDay.backgroundView.changeBackground(BlitzKriegGameMode.NORMAL, true);
            }
        }

        return value;
    }

    private createViewsAndComponents() {
        //Non views
        const sound = new BlitzKriegSound();
        const layers = new DDayLayers();
        //Views
        DDay.backgroundView = new DDayBackground();
        DDay.reelBackground = new DDayReelBackground();
        DDay.featureBackground = new DDayFeatureBackground();
        DDay.initialCountUp = new InitialWinCountUp();
        DDay.bigWinCountUp = new BigWinCountUp();
        DDay.freespinIntro = new DDayFreespinIntro();
        DDay.freespinOutro = new FreespinOutro();
        DDay.winCapScreen = new WinCapScreen();
        DDay.introSplash = new DDayIntroSplashView();
        DDay.scatterAnticipation = new DDayScatterAnticipationView();
        DDay.commonService = new CommonService();

        DDay.atomicWildAnimation = new DDayAtomicWildFeatureView();

        DDay.shake = new ShakeEffect();
        DDay.reels = [];
        for (let i: number = 0; i < DDayGameConfig.REELS_NUM; i++) {
            const reel = new BlitzKriegReelController(i);
            DDay.reels.push(reel);
        }
        DDay.reelStopPresentations = new ReelStopPresentationManager([
            new ReelStopSoundController()
        ]);
        DDay.reelStartPresentations = new ReelStartPresentationManager([
            new ReelStartSoundController()
        ]);
        DDay.winPresentations = new WinPresentationManager([
            new DDayGameFeatureController(),
            new InitialWinController(),
            new InitialWinCountUpController(),
            new BigWinController(),
            new DDayNoWinController(),
            new FreespinWinController(),
            new FreespinEndController(),
            new BreakBankController(),
        ]);
        DDay.individualWin = new IndividualWinController();

        if (DDay.model.isRestore && DDay.model.parsedInitData.showTotalWin) {
            SlotGame.keypadPlugin.setWin(DDay.model.parsedInitData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
        }

        if (DDay.model.isRestore || DDay.apiPlugin.isReplay) {
            DDay.reelBackground.enableLogo(true);
            DDay.reelBackground.enableRadioAndWaysFrame();
            DDay.reelBackground.setXWaysCount(720);
            if (DDay.model.isRestore) {
                let layer: StageLayer | undefined = DDayLayers.getLayer(Layers.LOW_SYMBOLS);
                if (layer) {
                    DDay.commonService.applyMaskOnReel(layer)
                }
            }
        }


        if (DDay.model.isRestore) {
            SlotGame.keypadPlugin.setWin(DDay.model.parsedInitData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
        }
        if (GameSetting.isDevMode) {
            // new Speedster();
            new TestTool();
        }
        // If restore, can be handled in these constructors directly.
    }

    public getNoWinGameData(): any {
        return DDayGameConfig.NO_WIN_REEL_DATA();
    }
}
